import styled from 'styled-components';
import slide3 from 'assets/images/desktop/slide3.jpg';
export { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  background: url(${slide3}) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  @media screen and (min-width: 2140px) {
    background-position-y: top;
  }
`;
